import { AppPaths } from "@p0security/shared/routes/constants";
import { Outlet, Route } from "react-router-dom";

import { ResourcesProvider } from "../../providers/ResourcesProvider";
import { Page } from "../App/Page";
import { JIT_ROUTING_ROLES } from "../App/roles";
import { EnvironmentProvider } from "../Environment/contexts/SelectedEnvironmentContext";
import { RoutingRules } from "../Jit/Routing";
import { AuthzGuard } from "../Login/AuthzGuard";
import { Policies } from "./Policies";
import { PolicyEditorPage } from "./PolicyEditorPage";

export const PoliciesRoutes = (
  <Route path={AppPaths.Policies} element={<Policies />}>
    <Route
      element={
        <AuthzGuard requirement={JIT_ROUTING_ROLES}>
          <Outlet />
        </AuthzGuard>
      }
    >
      <Route
        index
        element={
          <Page title="Routing Rules">
            <EnvironmentProvider>
              <ResourcesProvider>
                <RoutingRules />
              </ResourcesProvider>
            </EnvironmentProvider>
          </Page>
        }
      />
      <Route element={<AuthzGuard requirement={["owner"]} />}>
        <Route
          path="new"
          element={
            <Page title="Create Policy">
              <ResourcesProvider>
                <PolicyEditorPage />
              </ResourcesProvider>
            </Page>
          }
        />
        <Route
          path="edit/:ruleId"
          element={
            <Page title="Edit Policy">
              <ResourcesProvider>
                <PolicyEditorPage />
              </ResourcesProvider>
            </Page>
          }
        />
      </Route>
    </Route>
  </Route>
);
